<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="QR-Code bearbeiten">
      <qr-code-form
        :loading="loading"
        :qr-code="qrCode"
        :form-submitted="saveQrCode"
        mode="edit"
      ></qr-code-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import QrCodeForm from "@/components/forms/QrCodeForm"
import QrCodesRepository from "@/repositories/qr_codes_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "QR-Code bearbeiten"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    QrCodeForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: true,
      qrCode: {
        label: "",
        target_type: null,
        target_id: null
      }
    }
  },
  async created() {
    try {
      this.qrCode = await QrCodesRepository.get(this.$route.params.id)
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveQrCode(qrCode) {
      await QrCodesRepository.update(qrCode.id, qrCode)
      this.$router.push({ name: "QrCodesPage" })
    }
  }
}
</script>
